import { SelectOptionType } from '@octano/global-ui';

/**
 * Función para formatear las opciones del select de países
 * @param data Array con países {id, name}
 * @returns Array de opciones con los valores (value, label)
 */
export const formatBaseOption = (data: {
  id: string | number;
  name: string;
}): SelectOptionType => ({
  value: data.id,
  label: data.name,
});

/**
 * Función para formatear las opciones del select de países
 * @param data Array con países {id, name}
 * @returns Array de opciones con los valores (value, label)
 */
export function formatOptions(
  data: { id: string; name: string }[],
): SelectOptionType[] {
  return data.map(formatBaseOption);
}

/**
 * Devuelve el valor plano de un campo de select.
 *
 * La ficha guarda estos campos de DOS formas según por dónde entró el dato:
 * el formulario persiste la opción completa (`{ value, label }`) en
 * `dynamic_form_item`, mientras que el portal la desenvuelve a un escalar
 * (`'CO'`, `1`) en `tp_step_form_response`. Al hidratar hay que aceptar ambas.
 */
export function unwrapOptionValue(
  value: unknown,
): string | number | undefined | null {
  if (value && typeof value === 'object' && 'value' in value) {
    return (value as SelectOptionType).value;
  }
  return value as string | number | undefined | null;
}

export function getSelectedOption(
  id: string | number | undefined | SelectOptionType | null,
  options: SelectOptionType[],
) {
  const value = unwrapOptionValue(id);
  if (value === null || value === undefined) {
    return undefined;
  }
  // Comparación por string: los ids de catálogo (comuna/ciudad/región) son numéricos
  // en las opciones, pero pueden llegar como string (p.ej. el prefill desde la entidad
  // los serializa). `5 === "5"` era false y dejaba el select vacío; coercer evita ese
  // desajuste de tipo sin afectar los matches string↔string o número↔número.
  return options.find((row) => String(row.value) === String(value));
}
